<template>
  <section id="tools" class="py-20">
    <div class="max-w-6xl mx-auto px-6">
      <div class="text-center mb-12">
        <h2 class="text-3xl md:text-4xl font-bold mb-4" :class="isDark ? 'text-white' : 'text-gray-800'">
          开发工具
        </h2>
        <p :class="isDark ? 'text-gray-400' : 'text-gray-500'">提升开发效率的实用工具集合</p>
        <div class="w-20 h-1 bg-green-500 mx-auto mt-4"></div>
      </div>

      <div class="grid md:grid-cols-3 gap-6">
        <router-link
          v-for="tool in tools"
          :key="tool.id"
          :to="{ path: '/tools', query: { tool: tool.key } }"
          class="block rounded-xl p-6 border transition-all group"
          :class="isDark
            ? 'bg-gray-800 border-gray-700 hover:border-green-500/50 hover:bg-gray-800/80'
            : 'bg-gray-50 border-gray-200 hover:border-green-500/50 hover:bg-white hover:shadow-md'"
        >
          <div class="flex items-start gap-4">
            <div class="w-12 h-12 rounded-lg flex items-center justify-center flex-shrink-0 transition-transform group-hover:scale-110"
                 :class="tool.iconBg">
              <span class="text-2xl">{{ tool.emoji }}</span>
            </div>
            <div class="flex-1 min-w-0">
              <div class="flex items-center gap-2 mb-1">
                <h3 class="text-base font-semibold" :class="isDark ? 'text-white' : 'text-gray-800'">{{ tool.name }}</h3>
                <span class="text-[10px] px-1.5 py-0.5 rounded-full"
                      :class="isDark ? 'bg-gray-700 text-gray-400' : 'bg-gray-200 text-gray-500'">{{ tool.tag }}</span>
              </div>
              <p class="text-sm" :class="isDark ? 'text-gray-400' : 'text-gray-500'">{{ tool.description }}</p>
            </div>
          </div>
          <div class="mt-4 flex items-center text-xs font-medium transition-colors"
               :class="isDark ? 'text-green-400' : 'text-green-600'">
            <span>立即使用</span>
            <svg xmlns="http://www.w3.org/2000/svg" class="w-3.5 h-3.5 ml-1 transition-transform group-hover:translate-x-1"
                 fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
            </svg>
          </div>
        </router-link>
      </div>

      <div class="mt-8 text-center">
        <router-link to="/tools" class="inline-flex items-center gap-2 px-6 py-2.5 font-medium rounded-lg transition-colors text-sm"
                     :class="isDark ? 'bg-gray-800 text-gray-300 hover:bg-gray-700' : 'bg-gray-100 text-gray-600 hover:bg-gray-200'">
          <span>查看全部工具</span>
          <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
          </svg>
        </router-link>
      </div>
    </div>
  </section>
</template>

<script>
import { useTheme } from '../composables/useTheme'

export default {
  name: 'ToolsSection',
  setup() {
    const { isDark } = useTheme()
    return { isDark }
  },
  data() {
    return {
      tools: [
        {
          id: 1,
          key: 'random-string',
          name: '随机生成字符串',
          description: '支持自定义字符集、排除字符、批量生成',
          emoji: '🎲',
          tag: '字符串',
          iconBg: 'bg-purple-500/20'
        },
        {
          id: 2,
          key: 'string-length',
          name: '字符串长度',
          description: '统计字符数、字节数、行数、单词数等',
          emoji: '📏',
          tag: '字符串',
          iconBg: 'bg-blue-500/20'
        },
        {
          id: 3,
          key: 'time-convert',
          name: '时间转换',
          description: '时间戳与日期格式互转工具',
          emoji: '⏰',
          tag: '转换',
          iconBg: 'bg-green-500/20'
        }
      ]
    }
  }
}
</script>
